// src/locales/en.ts — English (base locale)
const en = {
  // Navigation
  'nav.dashboard': 'Dashboard',
  'nav.tests': 'Tests',
  'nav.sat': 'SAT',
  'nav.psat': 'PSAT',
  'nav.act': 'ACT',
  'nav.practice': 'Practice',
  'nav.learn': 'Learn',
  'nav.videos': 'Videos',
  'nav.bookmarks': 'Bookmarks',
  'nav.pricing': 'Pricing',
  'nav.groups': 'Groups',
  'nav.signIn': 'Sign in',
  'nav.signOut': 'Sign out',

  // Dashboard
  'dashboard.welcomeBack': 'Welcome back',
  'dashboard.scorePrediction': 'Score Prediction',
  'dashboard.studyPlan': 'Study Plan',
  'dashboard.quickDrill': 'Quick Drill',
  'dashboard.inviteFriends': 'Invite Friends',

  // Common
  'common.start': 'Start',
  'common.resume': 'Resume',
  'common.retake': 'Retake',
  'common.submit': 'Submit',
  'common.next': 'Next',
  'common.previous': 'Previous',
  'common.cancel': 'Cancel',
  'common.save': 'Save',
  'common.loading': 'Loading',

  // Results
  'results.score': 'Score',
  'results.correct': 'Correct',
  'results.incorrect': 'Incorrect',
  'results.time': 'Time',
  'results.viewResults': 'View Results',
  'results.downloadPdf': 'Download PDF',
  'results.share': 'Share',

  // Practice
  'practice.byTopic': 'Practice by Topic',
  'practice.checkAnswer': 'Check Answer',
  'practice.explanation': 'Explanation',

  // Pricing
  'pricing.freePlan': 'Free Plan',
  'pricing.proPlan': 'PRO Plan',
  'pricing.upgrade': 'Upgrade',
  'pricing.monthly': 'Monthly',
  'pricing.testsPerMonth': 'tests per month',
  'pricing.unlimited': 'Unlimited',

  // Language selector
  'language.label': 'Language',
} as const

export type TranslationKey = keyof typeof en
export default en
